var map = {
	"./Hyderabad.png": 726,
	"./Key.png": 727,
	"./No-data-page.svg": 728,
	"./PlusImg.png": 729,
	"./Quad3rick.png": 730,
	"./Star.png": 731,
	"./awards1.png": 732,
	"./awards2.png": 733,
	"./bg-img.png": 734,
	"./blog-img.png": 735,
	"./blog-img2.png": 736,
	"./blog-img3.png": 737,
	"./c6rrect.png": 738,
	"./captain-ic.png": 739,
	"./card-img.png": 740,
	"./card-img.svg": 741,
	"./checked-w.svg": 742,
	"./checked.svg": 743,
	"./circle-shape-png-hd-background-view-all-images.png": 744,
	"./circular-tick.png": 745,
	"./clock-ic.png": 746,
	"./coins.png": 747,
	"./coming-soon-img.png": 748,
	"./congrats-bg.png": 749,
	"./connection-bg.png": 750,
	"./crystall-ball-trophy.png": 751,
	"./default-team-img.svg": 752,
	"./default-user-old.png": 753,
	"./default-user.png": 754,
	"./default_Pan_Image.png": 755,
	"./eye-cancel-dark-green.png": 756,
	"./eye-cancel-dark.png": 757,
	"./eye-cancel.png": 758,
	"./eye-dark.png": 759,
	"./eye.png": 760,
	"./fan-challenge-bg.png": 761,
	"./fan-challenge-bg2.png": 762,
	"./flag_default.png": 763,
	"./full-logo.png": 764,
	"./golden-star.png": 765,
	"./gray-bg-img.png": 766,
	"./green-logo.png": 767,
	"./header-bg-full.png": 768,
	"./header-bg-white-full.png": 769,
	"./header-bg-white.png": 770,
	"./header-bg.png": 771,
	"./icon-coin.svg": 772,
	"./lb-banner.png": 773,
	"./like.svg": 774,
	"./logo-black.png": 775,
	"./logo-new.png": 776,
	"./logo-new.webp": 777,
	"./logo-purple.png": 778,
	"./logo.png": 779,
	"./lose.png": 780,
	"./lose.svg": 781,
	"./mark_zuckerberg.png": 782,
	"./medals.png": 783,
	"./membership-bg.png": 784,
	"./message.png": 785,
	"./minus-img.png": 786,
	"./modal-bg-img.png": 787,
	"./pause.png": 788,
	"./payment-method.png": 789,
	"./play.svg": 790,
	"./playbutton.png": 791,
	"./player-img.png": 792,
	"./reflive.svg": 793,
	"./refpay-header-bg.png": 794,
	"./refpay.svg": 795,
	"./refpredictor.svg": 796,
	"./refsocail-header-bg.png": 797,
	"./refsocial.svg": 798,
	"./remove-ic@1x.svg": 799,
	"./rpl-cup.png": 800,
	"./section1-bg.png": 801,
	"./shape_logo.svg": 802,
	"./singer-img.png": 803,
	"./singer-img2.png": 804,
	"./sponsered-img.png": 805,
	"./sweden.png": 806,
	"./team-flag.png": 807,
	"./team-logo-shadow.png": 808,
	"./team-logo.png": 809,
	"./team1.png": 810,
	"./team2.png": 811,
	"./thumbs-up.png": 812,
	"./tick.png": 813,
	"./tie.png": 814,
	"./tie.svg": 815,
	"./trophy-ic.png": 816,
	"./user-img2.png": 817,
	"./user-img3.png": 818,
	"./user-oldie.svg": 819,
	"./user.svg": 820,
	"./vinfotech-logo.png": 821,
	"./vissel-old.png": 822,
	"./vissel.svg": 823,
	"./wallet-oldie.svg": 824,
	"./wallet.png": 825,
	"./wallet.svg": 826,
	"./whatsapp.png": 827,
	"./whistle-shape-bg.png": 828,
	"./whistle-shape-bg_oldie.png": 829,
	"./win.png": 830,
	"./win.svg": 831,
	"./winning-ic.png": 832
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 725;